export const SEASONS = [
  "2024-25",
  "2023-2024",
  "2022-23",
  "2021-22",
  "2020-21",
  "2019-20",
];

export const CURRENT_SEASON = "2024-25";

export const CompletedRounds = [1, 2, 3, 4];
